/**
 * Canonical status-to-tone mapping.
 * Two domains: 'kpi' for metric status, 'request' for approval workflow status.
 * All components should import from here — do not define tone logic locally.
 */

const KPI_STATUS_TONES = {
  ahead: 'good',
  on_track: 'fair',
  behind: 'warning',
  partial: 'neutral',
  no_data: 'neutral'
};

const KPI_STATUS_LABELS = {
  ahead: 'Ahead',
  on_track: 'On Track',
  behind: 'Behind',
  partial: 'Partial',
  no_data: 'No Data'
};

const REQUEST_STATUS_TONES = {
  approved: 'approved',
  denied: 'denied',
  pending: 'pending',
  'review needed': 'review'
};

export function getKpiStatusTone(status) {
  return KPI_STATUS_TONES[String(status || '').toLowerCase()] || 'neutral';
}

export function getKpiStatusLabel(status) {
  return KPI_STATUS_LABELS[String(status || '').toLowerCase()] || 'No Data';
}

export function getRequestStatusTone(status) {
  const normalized = String(status || '').toLowerCase();
  if (normalized.includes('blocked')) return 'warning';
  return REQUEST_STATUS_TONES[normalized] || 'pending';
}

export function getStatusIndicatorLabel(tone) {
  if (tone === 'good') return 'Green';
  if (tone === 'fair') return 'Yellow';
  if (tone === 'warning') return 'Red';
  return 'Neutral';
}
